import axios from "axios";
import { dashboardHomeApi, dashboardMapStatsApi, dashboardProductStatsApi, dashboardStatsApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getDashboardHome = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardHomeApi, config);

    return response;
};

export const getDashboardHomeStats = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardMapStatsApi, config);

    return response;
};

export const getDashboardStats = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardStatsApi, config);

    return response;
};

export const getDashboardProductStats = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardProductStatsApi, config);

    return response;
};